var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent7(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 38,
    viewBox: "0 0 24 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.1454L20.02 30.3201H3.91458L0 11.1454C0.0567015 6.70819 3.31268 3.80393 6.03435 2.15309C7.75502 1.1093 9.48442 0.419262 10.625 0.0240202V14.2025C9.93367 14.6458 9.47351 15.421 9.47351 16.3054C9.47351 17.6833 10.5901 18.8013 11.9662 18.8013C13.3423 18.8013 14.4589 17.6833 14.4589 16.3054C14.4589 15.4232 14.0009 14.6458 13.3096 14.2025V0C14.4589 0.388691 16.2384 1.08746 18.0071 2.15309C20.7418 3.80393 24 6.70601 24 11.1454Z",
    fill: "#2A3281"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8453 32.2417H2.08264V38.0022H21.8453V32.2417Z",
    fill: "#2A3281"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent7);
export default __webpack_public_path__ + "static/media/event-7.91525fe98e3fa4bc3b407767f4613ee8.svg";
export { ForwardRef as ReactComponent };